import React, { useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

function Protected(props) {
    const clientIdFromRedux = useSelector(state => state.common.clientId);
    const history = useHistory();

    useEffect(() => {
        // Check if clientId exists in Redux state or not
        if (!clientIdFromRedux) {
            localStorage.clear();
            history.push("/");
            window.location.reload();
        }
    }, [clientIdFromRedux]);

    const Cmp = props.Cmp;
    
  // Conditional rendering of navigation based on clientId presence
  return (
    
    <div>
        {clientIdFromRedux ? (
            <div>
                    <Cmp />
            </div>
        ) : null}
    </div>
);
}
export default Protected;
